<div class="forms-details-view-container" *ngIf="dynamicFormObject" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxLayoutGap="15px">
    <button *ngIf="(userPermissions | async).form.admin_root " [disabled]="!(userPermissions | async).form.admin_root " (click)="modify()" mat-stroked-button color="primary">
      <mat-icon>create</mat-icon>
      <span> Edytuj</span>
    </button>

    <button *ngIf="(userPermissions | async).form.admin_root " [disabled]="!(userPermissions | async).form.admin_root " (click)="delete()"  mat-raised-button color="warn">
      <mat-icon>delete</mat-icon><span> Usuń</span>
    </button>
  </div>
  <div fxLayout="row" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Dane</h3>
        </div>
        <div fxLayout="column" fxLayoutGap="15px">
        <div fxLayout="column" fxLayoutGap="15px">
          <div fxFlex="100" >
            <app-detail  header="Nazwa " [value]="dynamicFormObject.name"></app-detail>
          </div>
          <div fxFlex="100" >
            <app-detail  header="UUID" (click)="copyMessage(dynamicFormObject.uuid)" [value]="dynamicFormObject.uuid" ></app-detail>
          </div>
          <div fxLayout="row">
            <app-detail-bool fxFlex="33"  header="Aktywny" [value]="dynamicFormObject.active"></app-detail-bool>
            <app-detail-bool fxFlex="33"  header="Wysyłka maili do administratora" [value]="dynamicFormObject.emailSend"></app-detail-bool>
            <app-detail-bool fxFlex="33"  header="Przypisanie struktury" [value]="dynamicFormObject.assignStructure"></app-detail-bool>
          </div>
          <div fxLayout="row">
             <app-detail-bool fxFlex="33"  header="Wysyłka maili do Partnera" [value]="dynamicFormObject.emailSendToAssignStructure"></app-detail-bool>
            <app-detail-bool fxFlex="33"  header="Czas obslugi" [value]="dynamicFormObject.serviceTime !=  0"></app-detail-bool>
            <app-detail-bool fxFlex="33"  header="Automatyczne tworzenie kont w ASF360" [value]="dynamicFormObject.creatingAccount"></app-detail-bool>
          </div>
          <div fxLayout="row">
            <app-detail-bool fxFlex="33"  header=" Wysyłka zwrotna do nadawcy" [value]="dynamicFormObject.emailReturnToSender"></app-detail-bool>
              </div>
          <div fxLayout="row" fxFlex="100">
            <app-detail fxFlex="50" header="Link do formularza " [value]="dynamicFormObject?.linkToForm"></app-detail>
          </div>
          <div fxFlex="100">
              <app-detail header="Lista adresów mailowych administratora" fxFlex="50" *ngIf="mailSend">
                <mat-chip-list>
                  <mat-chip *ngFor="let email of dynamicFormObject.emailAddressList" color="accent" selected>{{ email }}</mat-chip>
                </mat-chip-list>
              </app-detail>
          </div>
          <div fxFlex="100" *ngIf="dynamicFormObject.assignStructure">
            <app-detail fxFlex="50" header="Przykładowy link " [value]="dynamicFormObject.sampleLink"></app-detail>
          </div>
          <div fxFlex="100" *ngIf="serviceTime">
            <app-detail fxFlex="50" header="Czas obsługi">{{dynamicFormObject.serviceTime}} H</app-detail>
          </div>
        </div>
        </div>
      </mat-card>
      <mat-card fxLayout="column" fxFlex="100" fxLayoutGap="15px"  *ngIf="(userPermissions | async)?.user.read">
        <h3>
          Uprawnieni użytkownicy
        </h3>
        <div fxLayout="row">
          <div fxFlex="100">
            <app-dict-users
              class="user-list-filter"
              label="Użytkownik"
              [multiple]="true"
              [userFormsPermission]="true"
              [userPermissionsEditable]="true"
              [userPageSize] = 999
              [formControl]="permissionUserControl"
              [userNames]="usernames"
              [filterDynamicForm]= "true"
            ></app-dict-users>
          </div>
        </div>

      </mat-card>
      <mat-card  *ngIf="ownerSend">
        <div fxLayout="column" fxLayoutGap="15px">
          <div fxLayout="column" fxLayoutGap="15px">
            <div fxFlex="100" >
              <div fxLayout="row">
                <h3> Szablon email zwrotnego do Partnera  </h3>
              </div>

              <div fxLayout="row" >
                <app-detail fxFlex="100" header="Tytuł " [value]="dynamicFormObject?.emailTitle"></app-detail>
              </div>
              <div fxLayout="row" >
<!--                <app-detail fxFlex="100" header="Tytuł " [value]="dynamicFormObject?.emailTitle"></app-detail>-->
              </div>
              <div fxLayout="row">
                <angular-editor [config]="editorConfig" *ngIf="mailSend || ownerSend" [formControl]="contentEmailControl" fxFlex="100"></angular-editor>
              </div>
            </div>

          </div>
        </div>
      </mat-card>
      <mat-card  *ngIf="dynamicFormObject.emailReturnToSender">
        <div fxLayout="column" fxLayoutGap="15px">
          <div fxLayout="column" fxLayoutGap="15px">
            <div fxFlex="100"  fxLayoutGap="15px">
              <div fxLayout="row">
                <h3>  Szablon email zwrotnego do nadawcy  </h3>
              </div>
              <div fxLayout="row" fxLayoutGap="15px">
                <app-detail  fxFlex="100" header="Tytuł email  " [value]="dynamicFormObject.subjectEmailToReturnToSender"></app-detail>
              </div>
              <div fxLayout="row">
                <angular-editor [config]="editorConfig"  [formControl]="contentEmailToReturnToSenderControl" fxFlex="100"></angular-editor>
              </div>
            </div>

          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
